// Update in INS-2718
const OccupationValues = {
    FULL_TIME: 'full_time',
    PART_TIME: 'part_time',
    STUDENT: 'student',
    SELF: 'self',
    RETIRED: 'retired',
    NOT_EMPLOYED: 'not_employed',
};

export default OccupationValues;
